<template>
  <div id="page-ipr-platform-persona-form">
    <vs-row>
      <vs-col>
        <vs-row>
          <vs-col>
            <vue-element-loading :active="busy"></vue-element-loading>
            <card-page :card-title="cardTitle">
              <div class="m-4" v-if="value.System">
                <h5>This is a system persona, it cannot be edited</h5>
              </div>
              <vue-form-generator
                  class="pt-4"
                  ref="personaForm"
                  :model="model"
                  :options="formOptions"
                  :schema="schema"
              />
            </card-page>
              <vue-form-generator
                  ref="form"
                  :model="model"
                  :options="formOptions"
                  :schema="schemaPrivileges"
              />
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>


<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '../../../components/Views/CardPage';

const selectOptions = {
  showLabels: false,
  hideSelected: false,
  key: 'id',
  trackBy: 'id',
  label: 'name',
};

export default {
  name: 'PersonaForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    cardTitle: {
      type: String,
      required: false,
    },
    overrideSystemPersona: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [FormModelMixin],
  components: {
    CardPage
  },
  data() {
    return {
      model: {
        PersonaName: null,
        Role_FK: null,
        privileges: {}
      },
      checkboxStructure: [
        {
          mainLabel: 'IPR Platform',
          subMenu: [
            {
              sections: [
                {
                  label: 'Impersonate Company',
                  route: 'impersonate_company',
                  fields: ['View'],
                },
                {
                  label: 'Broker Tools',
                  route: 'broker_tools',
                  fields: ['View'],
                },
                {
                  label: 'Coverholder Suite',
                  route: 'coverholder_suite',
                  fields: ['View'],
                },
                {
                  label: 'Notify a Claim',
                  route: 'notify_a_claim',
                  fields: ['View'],
                },
                {
                  label: 'Work In Progress',
                  route: 'work_in_progress',
                  fields: ['View'],
                },
                {
                  label: 'Portfolio',
                  route: 'portfolio',
                  fields: ['View'],
                },
                {
                  label: 'Archive',
                  route: 'archive',
                  fields: ['View'],
                },
                {
                  label: 'Upload Quotation ',
                  route: 'upload_quotation',
                  fields: ['View'],
                },
                {
                  label: 'Request Referral',
                  route: 'request_referral',
                  fields: ['View'],
                },
              ],
            },
          ]
        },
      ],
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                disabled: !!this.value.System && !this.overrideSystemPersona,
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Name',
                model: 'PersonaName',
                required: true,
                validator: ['string', 'required'],
              },
            ]
          },
          {
            styleClasses: 'w-full',
            fields: [
              {
                disabled: !!this.value.System && !this.overrideSystemPersona,
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Role',
                model: 'Role_FK',
                required: true,
                validator: 'required',
                values: () => this.roles.map((role) => ({id: role.id, name: role.name})),
                selectOptions,
              },
            ]
          },
        ],
      },
      schemaPrivileges: {
        groups: [],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      formReferences: [
        'personaForm',
        'form',
      ],
      roles: [],
      options: [
        {
          endpoint: () => this.$api.iprPlatformPersonas.listAvailableRoles(this.$route.params.id),
          optionsFieldName: 'roles',
          nameFieldName: 'RoleName',
          idFieldName: 'Role_FK',
          additionalFields: [
            'applications',
          ],
        },
      ]
    };
  },
  methods: {
    async checkboxFields() {
      let fields = {};

      await this.checkboxStructure.forEach((structure) => {
        fields = {
          styleClasses: 'vx-card w-full custom-checkboxes-wrapper',
          fields: []
        };

        fields.fields.push({
          type: 'label',
          label: structure.mainLabel,
          styleClasses: 'w-11/12 main-label'
        })
        fields.fields.push({
          type: 'label',
          label: 'View',
          styleClasses: 'w-1/12 main-label field'
        })

        structure.subMenu.forEach((subMenu) => {
          subMenu.sections.forEach((section) => {
            fields.fields.push({
              type: 'label',
              label: section.label,
              styleClasses: 'w-11/12 field-group-label'
            })

            section.fields.forEach((field) => {
              const modelName = `privileges.${section.route}.${field}`;
              const modelNameBase = `privileges.${section.route}.`;
              let disabled = false;

              if (this.model.privileges[section.route]) {
                if (field === 'View'
                    && (parseInt(this.model.privileges[section.route].Edit)
                        || parseInt(this.model.privileges[section.route].Restore))
                ) {
                  disabled = true;
                }
              }

              if (this.value.System && !this.overrideSystemPersona) {
                disabled = true;
              }

              fields.fields.push({
                disabled: disabled,
                type: 'checkbox',
                styleClasses: 'w-1/12 field',
                model: modelName,
                onChanged: (model, value) => {
                  const formFields = this.$refs.form.$children;
                  model.privileges[section.route][field] = value;

                  if (value && (field === 'Edit' || field === 'Restore')) {
                    model.privileges[section.route].View = 1;
                  }

                  let viewDisabled = false;

                  // Only enable the list checkbox if all other fields are unchecked
                  section.fields.forEach((siblingField) => {
                    if ((siblingField === 'Restore' || siblingField === 'Edit')
                        && model.privileges[section.route][siblingField]
                    ) {
                      viewDisabled = true;
                    }
                  });

                  formFields.forEach((formField) => {
                    if (formField.field.model === modelNameBase + 'View') {
                      formField.field.disabled = viewDisabled;
                    }
                  });
                }
              });
            });
          });
        });

        this.schemaPrivileges.groups.push(fields);
      });
    },
  },
  async created() {
    await this.loadOpts();
    await this.checkboxFields();
  }
};
</script>

<style lang="scss">
#page-ipr-platform-persona-form {
  .vue-form-generator {
    .custom-checkboxes-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-top: 1rem;
      margin-top: 1rem;
      padding-bottom: 2rem;

      .main-label {
        border-bottom: 1px solid #d5dae075;
        margin-bottom: 0;

        label {
          span {
            margin: 0;
            font-size: 20px;
            color: #2c2c2c;
          }
        }

        &.field {
          border-right: 0;
          border-left: 1px solid #D5DAE0;
          display: flex;
          justify-content: center;
          align-items: flex-end;

          label {
            span {
              font-size: 15px;
            }
          }
        }
      }

      .field-group-label {
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin: 0;
        border-bottom: 1px solid #D5DAE0;
        padding: 1rem 0 1rem 1rem;

        label {
          span {
            margin: 0;
            font-size: 15px;
          }
        }
      }

      .field-checkbox {
        display: inline-flex;
        flex-direction: row;
        justify-content: center;
        margin: 0;
        border: 1px solid #D5DAE0;
        border-top: none;
        border-right: none;
        padding: 1.5rem 0;

        > div {
          input {
            margin: auto;
          }
        }
      }
    }
  }
}
</style>
